import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import i18n from 'Pods/Shared/I18n'

import withRouter from 'Pods/Shared/withRouter'

import Pagination from '../../Shared/Pagination/Pagination'
import Loader from '../../Shared/Loader'
import JobListItem from '../../Profile/JobsDashboard/JobsList/Components/JobListItem'

import ProjectsListFilters from './Components/ProjectsListFilters'
import MetaDataHelmet from '../../Shared/MetaDataHelmet'

class ProjectsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: this.getPreferredFilters(),
      localePath: props.locale !== 'en' ? `/${props.locale}` : '',
      data: [],
      perPageOptions: [
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 50, label: '50' },
      ],
      isDataFetched: false,
      dedicatedFilter: null,
      isMounted: true,
    }

    this.setFilerFromUrl(this.props.match.params.filter)

    this.onFetchDataSuccess = this.onFetchDataSuccess.bind(this)
    this.onFetchDataFailure = this.onFetchDataFailure.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.onTermChange = this.onTermChange.bind(this)
    this.onFiltersChange = this.onFiltersChange.bind(this)
    this.onPaginate = this.onPaginate.bind(this)
    this.onSortingChange = this.onSortingChange.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchData()
  }

  setFilerFromUrl(filter) {
    const filterFromUrl = this.resolveFilterFromUrl(filter)
    const newState = this.state

    if (filterFromUrl && ['skills', 'software'].includes(filterFromUrl.key)) {
      newState.filters = this.getDefaultFilters()
      newState.filters[filterFromUrl.key] = [filterFromUrl.value]
      newState.dedicatedFilter = filterFromUrl.title
      this.setState({ ...newState })
    } else {
      newState.dedicatedFilter = this.updateDedicatedUrl(this.state.filters)
      this.setState({ ...newState })
    }
  }

  resolveFilterFromUrl(filter) {
    if (this.props.skillsFilterOptions.map(filter => filter.slug).includes(filter)) {
      const selectedFilter = this.props.skillsFilterOptions.find(option => option.slug === filter)
      return { key: 'skills', value: selectedFilter.value, title: selectedFilter.label }
    } if (this.props.softwareFilterOptions.map(filter => filter.slug).includes(filter)) {
      const selectedFilter = this.props.softwareFilterOptions.find(option => option.slug === filter)
      return { key: 'software', value: selectedFilter.value, title: selectedFilter.label }
    }
    return null
  }

  componentWillUnmount() {
    this.cancelSource.cancel()

    this.setState({ isMounted: false })
  }

  getDefaultFilters() {
    return {
      page: 1,
      perPage: 10,
      sortBy: 'created_at',
      term: '',
      software: [],
      skills: [],
    }
  }

  getPreferredFilters() {
    let filters = {}

    try {
      filters = JSON.parse(sessionStorage.getItem('projects/filters')) || {}
    } catch (_e) {
    }

    return { ...this.getDefaultFilters(), ...filters }
  }

  setPreferredFilters(filters) {
    sessionStorage.setItem('projects/filters', JSON.stringify(filters))
  }

  fetchData(filters = { ...this.state.filters }) {
    axios.get('/api/internal/projects', { params: filters, cancelToken: this.cancelSource.token })
      .then(this.onFetchDataSuccess)
      .catch(this.onFetchDataFailure)
  }

  onFetchDataSuccess(response) {
    if (this.state.isMounted) {
      this.setState({
        data: response.data.data,
        meta: response.data.meta,
        isDataFetched: true,
      })
    }
  }

  onFetchDataFailure() {
    if (this.state.isMounted) {
      this.setState({ isDataFetched: true })
      App.events.publish('app:notification:flash:error', 'Error')
    }
  }

  onTermChange(term) {
    const newState = this.state

    newState.filters.term = term.target.value
    this.setPreferredFilters(newState.filters)
    this.setState({ ...newState })
  }

  onSearchSubmit(event) {
    event.preventDefault()

    const { filters } = this.state
    const { term } = filters
    const modelingJob = i18n.t('projects.ModelingJob', { ns: 'rails', lng: this.props.locale } )

    if (term.length > 0) {
      window.searchTracker({
        searchTerm: term,
        type: modelingJob,
      })
    }

    this.fetchData({ ...filters, page: 1 }, true)
  }

  onFiltersChange(newFilters) {
    newFilters = newFilters || this.state.filters
    newFilters.page = 1

    this.setPreferredFilters(newFilters)
    this.setState({ filters: newFilters, isDataFetched: false, dedicatedFilter: this.updateDedicatedUrl(newFilters) })
    this.fetchData({ ...newFilters }, true)
    this.props.onChange(newFilters)
  }

  updateDedicatedUrl(newFilters) {
    if (newFilters.skills.length === 1 && newFilters.software.length === 0) {
      const filter = this.props.skillsFilterOptions.find(option => option.value === newFilters.skills[0])
      this.props.history.push(`${this.state.localePath}/3d-modeling-jobs/browse/${filter.slug}`)
      return filter.label
    } if (newFilters.skills.length === 0 && newFilters.software.length === 1) {
      const filter = this.props.softwareFilterOptions.find(option => option.value === newFilters.software[0])
      this.props.history.push(`${this.state.localePath}/3d-modeling-jobs/browse/${filter.slug}`)
      return filter.label
    }
    this.props.history.push(`${this.state.localePath}/3d-modeling-jobs/browse`)
    return null
  }

  onPaginate(newFilters) {
    newFilters = newFilters || this.state.filters
    this.setPreferredFilters(newFilters)
    this.setState({ filters: newFilters, isDataFetched: false })
    this.fetchData({ ...newFilters }, true)
  }

  onSortingChange(sort) {
    const newState = this.state

    newState.filters.sortBy = sort.value
    newState.filters.page = 1
    this.setPreferredFilters(newState.filters)
    this.setState({ ...newState }, this.fetchData)
  }

  resolvePathname(job) {
    if (job.attributes.applicationId) {
      return job.attributes.archiveStatus === 'withdrawn' ? '' : `${this.state.localePath}/3d-modeling-jobs/browse/${job.attributes.slug}/${job.attributes.applicationId}/edit`
    }
    return `${this.state.localePath}/3d-modeling-jobs/browse/${job.attributes.slug}/apply`
  }

  render() {
    const newestFirst = i18n.t('projects.newestFirst', { ns: 'rails', lng: this.props.locale } )
    const highestBudget = i18n.t('projects.highestBudget', { ns: 'rails', lng: this.props.locale } )
    const fewestApplicants = i18n.t('projects.fewestApplicants', { ns: 'rails', lng: this.props.locale } )

    const sortingOptions = [{
      label: newestFirst,
      value: 'created_at',
    }, {
      label: highestBudget,
      value: 'budget',
    }, {
      label: fewestApplicants,
      value: 'applicants',
    }]

    return (
      <Fragment>
        <MetaDataHelmet
          title={this.state.dedicatedFilter ? `Find ${this.state.dedicatedFilter} jobs` : 'Browse 3D Modeling Jobs'}
          description={this.props.metaDescription}
        />
        <div className="container-fixed">
          <ProjectsListFilters
            filters={this.state.filters}
            sortOptions={sortingOptions}
            skillsFilterOptions={this.props.skillsFilterOptions}
            softwareFilterOptions={this.props.softwareFilterOptions}
            onSearchSubmit={this.onSearchSubmit}
            onTermChange={this.onTermChange}
            onSortChange={this.onSortingChange}
            onFiltersChange={this.onFiltersChange}
            locale={this.props.locale}
          />
        </div>

        <div className="projects-list">
          <div className="container-fixed">
            {this.state.isDataFetched ? (
              <Fragment>
                {this.state.data.map(job => (
                  job.attributes.isJobOwner ? (
                    <a
                      href={`/profile/projects/${job.id}`}
                      className={`card card--interactive job-list-item ${job.attributes.isFeatured ? 'is-featured' : ''}`}
                      key={job.id}
                    >
                      <JobListItem
                        key={job.id}
                        id={job.id}
                        isPublicListing={this.state.meta.isPublicListing}
                        {...job.attributes}
                      />
                    </a>
                  ) : (
                    <Link
                      to={{ pathname: this.resolvePathname(job) }}
                      className={`card card--interactive job-list-item ${job.attributes.isFeatured ? 'is-featured' : ''}`}
                      key={job.id}
                    >
                      <JobListItem
                        key={job.id}
                        id={job.id}
                        isPublicListing={this.state.meta.isPublicListing}
                        {...job.attributes}
                      />
                    </Link>
                  )
                ))}
                <Pagination
                  filters={this.state.filters}
                  perPageOptions={this.state.perPageOptions}
                  meta={this.state.meta}
                  onFiltersChange={this.onPaginate}
                  canJump={false}
                  pageRange={3}
                  title="jobs"
                />
              </Fragment>
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

ProjectsList.propTypes = {
  metaDescription: PropTypes.string.isRequired,
  skillsFilterOptions: PropTypes.array.isRequired,
  softwareFilterOptions: PropTypes.array.isRequired,
}

export default withRouter(ProjectsList)
